import { StyleProps } from '@bonusly/design-system';

export const getStyle = (isSelected?: boolean): StyleProps => ({
	alignItems: 'center',
	borderBottomColor: 'transparent',
	borderBottomWidth: '4px',
	color: 'text.softest',
	display: 'flex',
	fontSize: 'md',
	fontWeight: 'medium',
	pb: 2.5,
	pt: 3.5,
	px: 3,
	...(isSelected && {
		color: 'primary.fgStrong',
		borderBottomColor: 'primary.fgStrong',
	}),
});
